import { StoreState } from "../../models/states/StoreState";
import { VariableErrorModel } from "../VariableErrorModel";
import { makeMentionsSelector } from "../../redux/selectors/mentions";

const errorKey = "InvalidAnswer";

export default function maxMentions(variable) {
    const { name: variableName, maxMention } = variable;
    const mentionsSelector = makeMentionsSelector(variableName);

    return (getState: () => StoreState): VariableErrorModel => {
        const mentions = mentionsSelector(getState());
        const isValid = mentions.length <= maxMention;

        if (!isValid) {
            return { variableName, error: { key: errorKey } };
        }

        return null;
    };
}
